var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.955 13.0678C16.6567 13.0678 15.4006 12.8567 14.2289 12.4767C13.8594 12.35 13.4478 12.445 13.1628 12.73L11.5056 14.8094C8.51833 13.3844 5.72111 10.6928 4.23278 7.6L6.29111 5.84778C6.57611 5.55222 6.66056 5.14056 6.54444 4.77111C6.15389 3.59944 5.95333 2.34333 5.95333 1.045C5.95333 0.475 5.47833 0 4.90833 0H1.25611C0.686111 0 0 0.253333 0 1.045C0 10.8511 8.15944 19 17.955 19C18.7044 19 19 18.335 19 17.7544V14.1128C19 13.5428 18.525 13.0678 17.955 13.0678Z",
    fill: "#3B82F6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.a6ced0d3630981ec2c7dca9c82f2c8de.svg";
export { ForwardRef as ReactComponent };